<mds-dialog [dialogTitle]="title">
    <mds-dialog-content>
        <div class="flex flex-col pb-medpace overflow-clip gap-medpace">
            @if (bodyLines.length > 1) {
                @for (line of bodyLines; track $index) {
                    <span class="whitespace-pre-line">{{ line }}</span>
                }
            } @else {
                <span class="whitespace-pre-line">{{ bodyText }}</span>
            }
        </div>
    </mds-dialog-content>

    <mds-dialog-actions [align]="'end'">
        @if (displayCloseButton) {
            <mds-button
                [id]="'cancel-btn'"
                mat-button
                mat-dialog-close
                label="Close"
                variant="outline"
                (clickEvent)="close()"
            ></mds-button>
        }
    </mds-dialog-actions>
</mds-dialog>
